import { type ReactNode } from 'react';
import { Box, HStack, VStack, Heading, type BoxProps } from '@chakra-ui/react';
import { PROFILE_SECTION_BODY_SPACING, PROFILE_SECTION_HEADING_PROPS } from './profileSectionStyles';
import { CountryListGrid } from '../../components';
import { Card } from './Card';
import type { Country } from '@/models/country';

interface CountryListCardProps extends Omit<BoxProps, 'children'> {
  countryList: Country[];
  scrollContained?: boolean;
  /** Optional control beside the My List heading (e.g. score breakdown help). */
  headerAction?: ReactNode;
}

export function CountryListCard({
  countryList,
  scrollContained = true,
  headerAction,
  ...cardProps
}: CountryListCardProps) {
  const fillColumnHeight = scrollContained && countryList.length === 10;

  const heading = (
    <HStack spacing={2} align='center' justify='center' flexShrink={0} w='full'>
      <Heading {...PROFILE_SECTION_HEADING_PROPS}>My List</Heading>
      {headerAction}
    </HStack>
  );

  const list = (
    <CountryListGrid
      countryList={countryList}
      svg
      fillColumnHeight={fillColumnHeight}
      compactMobile={!scrollContained}
    />
  );

  if (!scrollContained) {
    return (
      <Card w='full' {...cardProps}>
        <VStack spacing={PROFILE_SECTION_BODY_SPACING} align='stretch'>
          {heading}
          {list}
        </VStack>
      </Card>
    );
  }

  return (
    <Card
      w='full'
      borderRadius={0}
      display='flex'
      flexDirection='column'
      minH={0}
      {...cardProps}
    >
      <Box flex={1} minH={0} display='flex' flexDirection='column'>
        <VStack flex={1} minH={0} spacing={PROFILE_SECTION_BODY_SPACING} align='stretch'>
          {heading}
          <Box flex={1} minH={0} overflowY='auto' overflowX='hidden' display='flex' flexDirection='column'>
            {list}
          </Box>
        </VStack>
      </Box>
    </Card>
  );
}
